module.exports = __webpack_public_path__ + "static/media/gym-zoomed-1.0f048044.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/backgrounds/gym-zoomed-1.jpg
// module id = 2384
// module chunks = 0